var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.701,
    height: 7.691,
    viewBox: "0 0 13.701 7.691",
    transform: "rotate(0)",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_17531",
    "data-name": "Path 17531",
    d: "M7.483,7.385l-5.826,6.1a.7.7,0,0,1-1.013,0l-.429-.449a.775.775,0,0,1,0-1.06l4.892-5.12L.209,1.728a.776.776,0,0,1,0-1.06L.638.219a.7.7,0,0,1,1.013,0l5.832,6.1a.782.782,0,0,1,0,1.064Z",
    transform: "translate(0 7.691) rotate(-90)",
    fill: "#564863"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUp);
export default __webpack_public_path__ + "static/media/icon-up.de1fc0035f03c6625d13c5c883bff427.svg";
export { ForwardRef as ReactComponent };